import * as i0 from "@angular/core";
export class CanActivatePtwService {
    constructor() { }
    canActivate(route, state) {
        return true;
    }
}
CanActivatePtwService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function CanActivatePtwService_Factory() { return new CanActivatePtwService(); }, token: CanActivatePtwService, providedIn: "root" });
